let allProducts = [];
let selectedProducts = []; // Array to allow multiple products

document.addEventListener('DOMContentLoaded', () => {
    fetchProducts().then(() => {
        // Hydrate from localStorage JSON after products are loaded
        loadSavedProducts();
        checkUrlParamsAndSelectProduct();
    });
    setupAutocomplete();
});

async function fetchProducts() {
    const apiUrl = 'https://api.dorel.com.br/v1/catalog/product_assistances';
    const fallbackUrl = 'assets/data/products.json';

    try {
        let response = await fetch(apiUrl);
        if (!response.ok) throw new Error('API CORS or Network error');
        let data = await response.json();
        processProducts(data);
    } catch (e) {
        console.warn('API Dorel failed, using local fallback JSON.', e);
        try {
            let response = await fetch(fallbackUrl);
            let data = await response.json();
            processProducts(data);
        } catch (fallbackError) {
            console.error('Fatal: Could not load products from API nor fallback.', fallbackError);
        }
    }
}
/*async function fetchProducts() {
    const apiUrl = 'https://proxy-registro.vercel.app/api/proxy/v1/catalog/product_assistances';

    try {
        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error(`API error: ${response.status}`);
        const data = await response.json();
        processProducts(data);
    } catch (e) {
        console.error('Fatal: Could not load products from API.', e);
    }
}*/

function processProducts(data) {
    if (!data || !Array.isArray(data)) return;

    // Filter by the brand name from configuration
    const brandName = window.currentBrand?.brand_name;

    allProducts = data.filter(p => {
        if (!p.brand_name) return false;
        const normalizedItemBrand = p.brand_name.toLowerCase().replace(/[- ]/g, '');
        const normalizedConfigBrand = brandName.toLowerCase().replace(/[- ]/g, '');
        return normalizedItemBrand === normalizedConfigBrand;
    });

    console.log(`[API] Loaded ${allProducts.length} products for brand ${brandName}`);
}

/**
 * Deriva as flags de garantia a partir do produto.
 * Regras:
 *  - O caractere '+' na string `warranty` indica que existe garantia estendida
 *    (algo além da garantia padrão).
 *  - O caractere '*' indica que a garantia estendida depende do cadastro do selo.
 *  - O input de número do selo só é exigido quando `guarantee_seal` é true
 *    E a `warranty` contém '+' e '*'.
 */
function getWarrantyFlags(product) {
    const warrantyText = product.warranty || '';
    const hasExtendedWarranty = warrantyText.includes('+'); // '+' => garantia além da padrão
    const hasSealMarker = warrantyText.includes('*');       // '*' => exige cadastro de selo

    return {
        hasExtendedWarranty,
        hasSealMarker,
        // Caso 1: selo verde (estendida) + input habilitado + texto extra
        requiresSeal: product.guarantee_seal === true && hasExtendedWarranty && hasSealMarker,
        // Selo verde sempre que houver garantia estendida (presença de '+')
        isExtended: hasExtendedWarranty,
    };
}
function setupAutocomplete() {
    const searchInput = document.getElementById('productSearch');
    const dropdown = document.getElementById('productDropdown');

    if (!searchInput || !dropdown) return;

    let debounceTimer;

    searchInput.addEventListener('input', (e) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            const query = e.target.value.toLowerCase().trim();
            if (query.length < 2) {
                dropdown.classList.add('hidden');
                return;
            }

            const matches = allProducts.filter(p => {
                const name = (p.name || '').toLowerCase();
                const ref = (p.reference || '').toLowerCase();
                return name.includes(query) || ref.includes(query);
            });

            renderDropdown(matches);
        }, 300);
    });

    // Close dropdown on outside click
    document.addEventListener('click', (e) => {
        if (!searchInput.contains(e.target) && !dropdown.contains(e.target)) {
            dropdown.classList.add('hidden');
        }
    });

    // Make sure click on input with value opens it
    searchInput.addEventListener('focus', (e) => {
        if (e.target.value.trim().length >= 2) {
            searchInput.dispatchEvent(new Event('input'));
        }
    });
}

function renderDropdown(matches) {
    const dropdown = document.getElementById('productDropdown');
    dropdown.innerHTML = '';

    if (matches.length === 0) {
        dropdown.innerHTML = '<div class="p-4 text-sm text-gray-500">Nenhum produto encontrado.</div>';
        dropdown.classList.remove('hidden');
        return;
    }

    const results = matches;

    results.forEach(product => {
        const item = document.createElement('div');
        item.className = 'p-3 hover:bg-brand-primary/5 cursor-pointer border-b border-gray-100 last:border-0 transition-colors flex flex-col';
        item.innerHTML = `
            <span class="font-bold text-brand-primary text-sm">${product.name} <span class="text-gray-400 font-normal">(${product.reference || 'N/A'})</span></span>
            <span class="text-xs text-gray-500">${product.category || 'Geral'}</span>
        `;

        item.addEventListener('click', () => {
            selectProduct(product);
        });
        dropdown.appendChild(item);
    });

    dropdown.classList.remove('hidden');
}

function selectProduct(product, preselectedSku = null) {
    // Add unique internal ID to manage selection
    const productEntry = {
        _id: Date.now().toString(),
        ...product,
        selectedColorIndex: null, // to be picked
        warrantyCode: '' // to be typed
    };

    // Auto-select color if only one item available
    const validItems = Array.isArray(product.items) ? product.items : [];
    if (preselectedSku) {
        const idx = validItems.findIndex(i => i.sku === preselectedSku);
        if (idx !== -1) productEntry.selectedColorIndex = idx;
    } else if (validItems.length === 1) {
        productEntry.selectedColorIndex = 0;
    }

    selectedProducts.push(productEntry);

    const searchInput = document.getElementById('productSearch');
    const dropdown = document.getElementById('productDropdown');
    searchInput.value = ''; // clear for next search
    dropdown.classList.add('hidden');

    saveSelectedProductsToInput();
    renderSelectedProducts();
}

window.removeProduct = function (id) {
    selectedProducts = selectedProducts.filter(p => p._id !== id);
    saveSelectedProductsToInput();
    renderSelectedProducts();
};

window.clearSelectedProducts = function () {
    selectedProducts = [];
    saveSelectedProductsToInput();
    renderSelectedProducts();
};

window.updateProductMetadata = function (id, key, value) {
    const p = selectedProducts.find(x => x._id === id);
    if (p) {
        p[key] = value;
        saveSelectedProductsToInput();

        if (key === 'selectedColorIndex') {
            // Re-render to update the image preview based on color
            renderSelectedProducts();
        }
    }
};

function saveSelectedProductsToInput() {
    const input = document.getElementById('selected_products_json');
    if (input) {
        input.value = JSON.stringify(selectedProducts);
        // Dispatch event so form.js logic picks it up on state save boundaries
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        if (typeof saveFormState === 'function') saveFormState();
    }
}

function loadSavedProducts() {
    const rawState = localStorage.getItem('dorel_registration_state');
    if (rawState) {
        try {
            const state = JSON.parse(rawState);
            if (state.selected_products_json) {
                const parsed = JSON.parse(state.selected_products_json);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    selectedProducts = parsed;
                    renderSelectedProducts();
                    return;
                }
            }
        } catch (e) { 
            console.error('Failed to parse saved registration state', e);
        }
    }

    const input = document.getElementById('selected_products_json');
    if (input && input.value && input.value !== '[]') {
        try {
            selectedProducts = JSON.parse(input.value);
            renderSelectedProducts();
        } catch (e) {
            console.error('Failed to parse hydrated products JSON', e);
        }
    }
}

window.formatWarrantyObject = function (input, productId) {
    let value = input.value.replace(/\D/g, '');
    if (value.length > 9) value = value.slice(0, 9);
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    input.value = value;
    updateProductMetadata(productId, 'warrantyCode', value);
}

function checkUrlParamsAndSelectProduct() {
    const params = new URLSearchParams(window.location.search);
    const prd = params.get('prd');
    const skuParam = params.get('sku');
    const code = params.get('code');

    let modified = false;

    if (prd) {
        const found = allProducts.find(p => p.id === prd);
        if (found && !selectedProducts.some(sp => sp.id === found.id)) {
            selectProduct(found, null);
            modified = true;
        }
    }

    if (skuParam) {
        const skus = skuParam.split(',').map(s => s.trim()).filter(s => s);

        skus.forEach(sku => {
            const found = allProducts.find(p => {
                if (Array.isArray(p.items)) {
                    return p.items.some(i => i.sku === sku);
                }
                return false;
            });

            if (found && !selectedProducts.some(sp => sp.id === found.id)) {
                // selectProduct automatically handles inserting it to the array
                selectProduct(found, sku);
                modified = true;

                // If there's a warranty code, apply it only when the product actually
                // requires a seal (guarantee_seal true + warranty com '+' e '*').
                const { requiresSeal } = getWarrantyFlags(found);
                if (code && requiresSeal) {
                    const addedProductIndex = selectedProducts.length - 1;
                    const addedProduct = selectedProducts[addedProductIndex];

                    // Format the code
                    let formattedCode = code.replace(/\D/g, '');
                    if (formattedCode.length > 9) formattedCode = formattedCode.slice(0, 9);
                    formattedCode = formattedCode.replace(/(\d{3})(\d)/, '$1.$2');
                    formattedCode = formattedCode.replace(/(\d{3})(\d)/, '$1.$2');

                    addedProduct.warrantyCode = formattedCode;
                    saveSelectedProductsToInput();
                    renderSelectedProducts();
                }
            }
        });
    }

    if (modified) {
        const url = new URL(window.location);
        url.search = '';
        window.history.replaceState({}, document.title, url);
    }
}

function renderSelectedProducts() {
    const container = document.getElementById('selectedProductsList');
    if (!container) return;

    const tipsSection = document.getElementById('tipsSection');
    if (tipsSection) {
        if (selectedProducts.length > 0) {
            tipsSection.classList.remove('hidden');
        } else {
            tipsSection.classList.add('hidden');
        }
    }

    container.innerHTML = '';

    selectedProducts.forEach(p => {
        const validItems = Array.isArray(p.items) ? p.items : [];
        const colorItem = (p.selectedColorIndex !== null && validItems[p.selectedColorIndex]) ? validItems[p.selectedColorIndex] : (validItems.length > 0 ? validItems[0] : null);
        // Flags de garantia centralizadas
        const { requiresSeal, isExtended } = getWarrantyFlags(p);
        let imageUrl = '';
        if (colorItem && colorItem.image_url) {
            imageUrl = colorItem.image_url;
        }

        const card = document.createElement('div');
        card.className = "bg-white border border-gray-200 rounded-2xl p-6 md:p-8 relative shadow-sm flex flex-col gap-6 w-full mt-2";

        let html = `
            <button type="button" class="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-red-100 text-red-600 hover:bg-red-200 transition-colors flex items-center justify-center font-bold text-sm shadow-md z-10" onclick="removeProduct('${p._id}')" title="Remover Produto">
                X
            </button>
        `;

        html += `<div class="flex flex-col md:flex-row gap-8 items-start w-full">`;

        html += `
            <div class="w-full md:w-48 h-48 bg-white rounded-xl border border-gray-100 p-4 flex items-center justify-center shrink-0 shadow-sm relative">
               ${imageUrl ? `<img src="${imageUrl}" alt="Produto" class="w-full h-full object-contain">` : `<div class="w-full h-full bg-gray-50 flex items-center justify-center text-gray-300 rounded"><svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg></div>`}
            </div>
        `;

        html += `<div class="flex flex-col gap-1 w-full">`;

                // Badge de garantia:
        //  - Caso 1 (exige selo): verde "GARANTIA ESTENDIDA APLICÁVEL"
        //  - Caso 2 (estendida sem selo): verde "GARANTIA ESTENDIDA"
        //  - Demais (sem '+'): amarelo "GARANTIA PADRÃO"
        const extendedBadgeText = requiresSeal ? 'GARANTIA ESTENDIDA APLICÁVEL' : 'GARANTIA ESTENDIDA';
        html += `
          <div class="flex flex-row justify-between items-start w-full gap-4 mb-1">
             <span class="text-xs uppercase tracking-widest text-[#e50695] font-bold mt-1">${p.category || 'Categoria'}</span>
             ${isExtended ?
                `<div class="px-3 py-1 bg-[#d1fad8] text-[#0f5c2e] font-bold uppercase text-[10px] md:text-xs rounded-full flex items-center gap-1 shrink-0"><svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> ${extendedBadgeText}</div>` :
                `<div class="px-3 py-1 bg-[#fdf2e3] text-[#b88c47] font-bold uppercase text-[10px] md:text-xs rounded-full flex items-center gap-1 shrink-0"><svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path></svg> GARANTIA PADRÃO</div>`
            }
          </div>
        `;
                // Quantidade de meses (campo warranty) ACIMA do título — para todos os casos, texto reduzido.
        if (p.warranty) {
            html += `<p class="text-[11px] md:text-xs text-gray-500 font-medium mt-1 leading-snug">${p.warranty}</p>`;
        }
 
        // Informativo logo abaixo dos meses — para todos os casos.
        //  - Com garantia estendida ('+'): aplicável mediante registro do produto
        //  - Sem garantia estendida: produto não elegível
        const warrantyNote = isExtended
            ? '*Garantia estendida aplicável mediante registro do produto'
            : '*Produto não elegível a garantia estendida';
        html += `
          <p class="text-[10px] md:text-[11px] text-gray-400 mt-0.5 leading-snug">
            ${warrantyNote}
          </p>
        `;
 

        // Título do produto
        html += `<h3 class="font-display text-2xl md:text-3xl text-[#655CD6] font-bold mb-3">${p.name} <span class="text-base font-normal text-gray-500">(${p.reference || ''})</span></h3>`;

        if (validItems.length > 1) {
            let optionsHtml = `<option value="" disabled ${p.selectedColorIndex === null ? 'selected' : ''}>Selecione a cor...</option>`;
            validItems.forEach((c, idx) => {
                optionsHtml += `<option value="${idx}" ${p.selectedColorIndex == idx ? 'selected' : ''}>${c.sku} - ${c.color_name}</option>`;
            });

            html += `
              <div class="mt-2 flex flex-col gap-1.5 relative max-w-sm w-full">
                 <label class="font-semibold text-[#655CD6] text-sm text-left">Cor do Produto</label>
                 <select class="w-full text-[#655CD6] border border-gray-300 rounded-lg h-12 pl-4 pr-10 appearance-none bg-white focus:outline-none focus:border-[#1c3f60] font-medium text-sm"
                    onchange="updateProductMetadata('${p._id}', 'selectedColorIndex', this.value)">
                    ${optionsHtml}
                 </select>
                 <div class="absolute inset-y-0 right-0 top-6 flex items-center pr-4 pointer-events-none text-gray-500">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path></svg>
                 </div>
              </div>
            `;
        } else if (validItems.length === 1) {
            html += `<p class="text-gray-500 font-medium text-sm mt-1">Cor: ${validItems[0].color_name}</p>`;
        }

        let linkBtns = '';
        if (p.youtube_code) {
            linkBtns += `
             <button type="button" onclick="openVideoModal('${p.youtube_code}')" class="btn-primary text-white text-sm font-semibold rounded-lg px-6 h-11 flex items-center gap-2 h transition-colors">
               <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
               Vídeo
             </button>
           `;
        }

        if (p.manuals && Array.isArray(p.manuals) && p.manuals.length > 0) {
            const manualsEncoded = encodeURIComponent(JSON.stringify(p.manuals));
            linkBtns += `
             <button type="button" onclick="openManualsModal('${manualsEncoded}')" class="btn-primary text-white text-sm font-semibold rounded-lg px-6 h-11 flex items-center gap-2  transition-colors">
               <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
               Manuais
             </button>
           `;
        }

        if (linkBtns !== '') {
            html += `<div class="flex flex-wrap gap-4 mt-5 w-full justify-start">${linkBtns}</div>`;
        }

        html += `</div>`;
        html += `</div>`;

        // Input do selo: somente quando o produto exige cadastro de selo (Caso 1)
        if (requiresSeal) {
            html += `
            <div class="mt-2 pt-6 border-t border-gray-100 flex flex-col gap-2 relative">
              <label class="font-semibold text-[#655CD6] text-sm flex items-center gap-2">
                Número do Selo de Garantia
                <span title="Normalmente na base do produto." class="text-gray-400 cursor-help flex items-center gap-1 font-normal text-xs mb-0.5">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                  *Informação obrigatória para ativar a garantia estendida.
                </span>
              </label>
              <input type="text" placeholder="Ex: 991.903.532" maxlength="11"
                class="w-full font-mono text-base tracking-wider border border-gray-300 rounded-lg p-3 bg-white focus:outline-none focus:border-brand-primary h-12" 
                value="${p.warrantyCode || ''}"
                oninput="formatWarrantyObject(this, '${p._id}')">
            </div>
            `;
        }

        card.innerHTML = html;
        container.appendChild(card);
    });
}

// `advance` controla se, ao passar na validação, avança para o Passo 2.
//  - true  (padrão): usado pelo botão "Avançar Passo" do Passo 1.
//  - false: usado no submit apenas para checar a etapa sem navegar adiante.
// Retorna `true` quando a etapa é válida e `false` quando há erro.
window.validateStep1 = function (advance = true) {
    const errorDiv = document.getElementById('step1Error');
    const showError = (msg) => {
        if (!errorDiv) return;
        errorDiv.textContent = msg;
        errorDiv.classList.remove('hidden');
    };

    if (errorDiv) errorDiv.classList.add('hidden');

    if (selectedProducts.length === 0) {
        showError("Por favor, busque e selecione pelo menos um produto para continuar.");
        return false;
    }

    for (let p of selectedProducts) {
        // Só exige o selo quando o produto realmente o requer (mesma regra do render)
        const { requiresSeal } = getWarrantyFlags(p);
        if (requiresSeal && (!p.warrantyCode || p.warrantyCode.trim().length < 5)) {
            showError("O preenchimento do Selo de Garantia é obrigatório para o produto: " + p.name);
            // Optionally, scroll to the card: document.getElementById('selectedProductsList').scrollIntoView({ behavior: 'smooth' })
            return false;
        }

        let validItems = Array.isArray(p.items) ? p.items : [];
        if (validItems.length > 1 && p.selectedColorIndex === null) {
            showError("Por favor, selecione a cor do produto: " + p.name);
            return false;
        }
    }

    // Move to next step via main.js (somente quando acionado pelo botão "Avançar Passo")
    if (advance) {
    if (typeof nextStep === 'function') nextStep(2);
    else console.error("Global nextStep not found.");
    }
    return true;
}

// Global Modal Handlers
window.openVideoModal = function (code) {
    const modal = document.getElementById('modalGeneric');
    const title = document.getElementById('modalGenericTitle');
    const content = document.getElementById('modalGenericContent');

    title.textContent = 'Vídeo do Produto';
    content.innerHTML = `<iframe class="w-full h-[50vh] md:h-[70vh]" src="https://www.youtube.com/embed/${code}?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;

    modal.classList.remove('hidden');
    modal.classList.add('flex');
}

window.openManualsModal = function (manualsStr) {
    const manuals = JSON.parse(decodeURIComponent(manualsStr));
    const modal = document.getElementById('modalGeneric');
    const title = document.getElementById('modalGenericTitle');
    const content = document.getElementById('modalGenericContent');

    title.textContent = 'Manuais Disponíveis';

    let html = '<div class="p-4 md:p-6 flex flex-col gap-4">';
    manuals.forEach(m => {
        html += `<a href="${m.url}" target="_blank" class="p-4 bg-white border border-gray-200 rounded-xl hover:border-brand-primary flex justify-between items-center group transition-colors shadow-sm">
            <span class="font-semibold text-brand-primary group-hover:text-brand-accent">${m.name || 'Baixar Manual'}</span>
            <svg class="w-5 h-5 text-gray-400 group-hover:text-brand-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg>
        </a>`;
    });
    html += '</div>';

    content.innerHTML = html;
    modal.classList.remove('hidden');
    modal.classList.add('flex');
}

window.closeGenericModal = function () {
    const modal = document.getElementById('modalGeneric');
    modal.classList.add('hidden');
    modal.classList.remove('flex');
    document.getElementById('modalGenericContent').innerHTML = ''; // wipe iframe to stop play
}